import UseSEO from 'hooks/useSEO/UseSEO';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    updateSelectedLine,
    updateSubLines,
    updateSelectedSubLine,
    updateDirections,
    updateSelectedLineDirection,
    lineState,
    updateStopsLine,
    directionsState,
    subLineState,
    selectedLineDirectionState,
    selectedLineState,
} from 'redux/slices/linesSlice';
import { useSelector } from 'react-redux';
import { useLazyGetLineShapeTripQuery,
  useLazyGetSubLineDirectionsQuery,
  useLazyGetSubLinesQuery,
  useLazyGetLinesBothTypesStopsTripQuery }
from 'redux/services/linesService';
import { updateShowLoading } from 'redux/slices/contextualSlice';
import {
  updateDrawMarker,
  updateMarkerSelected,
  updateMarkerSelectedType,
  updateMarkers,
  // updatePolylines
} from 'redux/slices/mapSlice';
import { updateContextualMessage } from 'redux/slices/contextualSlice';
import { updateSelectedStop } from 'redux/slices/stopsSlice';
import { TYPES_MARKERS, RUTAS_GENERALES_MUL2 } from 'utils/constants';
import MarkerDetailStopLineCard from 'components/features/markerDetailStopLineCard/MarkerDetailStopLineCard';
import { useTranslate } from 'context/languageContext';

export default function UseLines() {
    const t = useTranslate();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [ generateUrl ] = UseSEO();
    const [GetSubLineDirections] = useLazyGetSubLineDirectionsQuery();
    const [GetSubLines] = useLazyGetSubLinesQuery();
    const [GetLineStopWithTrip] = useLazyGetLinesBothTypesStopsTripQuery();
    const selectorLines = useSelector(lineState);
    const selectedLine = useSelector(selectedLineState);
    const selectorDirections = useSelector(directionsState);
    const [GetLineShapeTrip] = useLazyGetLineShapeTripQuery();
    const subLinesSelector = useSelector(subLineState);
    const selectedDirectionSelector = useSelector(selectedLineDirectionState);

    const getLineInfo = async (line, subline: string | undefined = undefined) => {
      dispatch(updateSelectedLine(line));
      dispatch(updateSubLines([]));
      await GetSubLines(line?.id).then(async (result: any) => {
        dispatch(updateSelectedSubLine(null));
        if (result.data) {
          if (result.data.length) {
            await GetSubLineDirections(result.data[0].subLineId).then((res: any) => {
              if (res.data) {
                if (res.data.length) {
                  dispatch(updateDirections(res.data));
                  const sLine = res.data[0] || {};
                  const dir = { ...sLine, subLineId: result.data[0].subLineId };
                  dispatch(updateSelectedLineDirection(dir));
                  navigate(
                    generateUrl(RUTAS_GENERALES_MUL2.lines, 'LINEA', {
                      linea: line,
                      direccion: { ...dir, subLineId: dir?.subLineId },
                    }),
                  );
                }
              }
            });
            dispatch(updateSubLines(result.data));
            dispatch(
              updateSelectedSubLine(
                subline !== undefined
                  ? result.data.find((element) => element.subLineId === subline)
                  : result.data[0],
              ),
            );
          }
        }
      });
    };

    type Point = [number, number]; // Define un tipo para los puntos

    const setSmoothedPoints = (points: Point[], windowSize: number = 3): Point[] => {
      const smoothedPoints: Point[] = [];
      const halfWindow = Math.floor(windowSize / 2);

      // Crear los pesos para la ventana
      const weights = Array.from({ length: windowSize }, (_, i) => halfWindow + 1 - Math.abs(halfWindow - i));
      // const weightSum = weights.reduce((sum, w) => sum + w, 0); // Suma total de los pesos

      for (let i = 0; i < points.length; i++) {
        let weightedSumX = 0, weightedSumY = 0;
        let totalWeight = 0;

        for (let j = -halfWindow; j <= halfWindow; j++) {
          const index = i + j;
          if (index >= 0 && index < points.length) {
            const weight = weights[j + halfWindow];
            weightedSumX += points[index][0] * weight;
            weightedSumY += points[index][1] * weight;
            totalWeight += weight;
          }
        }

        // Dividir por la suma total de pesos calculada dinámicamente en los bordes
        smoothedPoints.push([weightedSumX / totalWeight, weightedSumY / totalWeight]);
      }
      return smoothedPoints;
    };

    const getStops = async (line, direction, onClickStop, onMarkerClose) => {
      updateShowLoading(true);
      let paradasConLineas;
      if(line?.id && direction?.tripId) {
        await GetLineStopWithTrip({ id: line?.id, tripId: direction?.tripId })
          .then((response) => {
            if (response.status === 'rejected') {
              // setStops([]);
            } else {
              const paradasSinLineas = response.data;
              paradasConLineas = paradasSinLineas.map((stop) => {
                const lineasDeParada = stop.linesBoth;
                const paradaConLineaAux = {
                  ...stop,
                  lines: lineasDeParada
                    .filter((item) => item.routeId !== line.id)
                    .map((l) => selectorLines.find((item) => item.id === l.routeId))
                    .filter((item) => item !== undefined),
                };
                return paradaConLineaAux;
              });

              const markersStops: Array<any> = [];
              for (let i = 0; i < paradasConLineas.length; i++) {
                const stop = paradasConLineas[i];
                const index = i;

                let formartedMarker: any = {
                  id: stop.id,
                  position: { lat: stop.stopLat, lng: stop.stopLon },
                  data: {
                    name: stop.stopName,
                    stopCode:stop.stopCode,
                    routeColor: line.routeColor,
                    first: index === 0,
                    last:(paradasConLineas.length-1) === index,
                    onclickPasoPorParada: () => {
                      dispatch(updateMarkerSelected(stop.id));
                      dispatch(updateSelectedStop(stop));
                      dispatch(updateMarkerSelectedType(TYPES_MARKERS.STOP));
                      navigate(
                        generateUrl(RUTAS_GENERALES_MUL2.paradas, 'STOP', {
                          code: stop.stopCode,
                          name: stop.stopName,
                        }),
                      );
                    },
                  },
                  popUp: false,

                  type: 'CIRCLESTOP',
                  onClick: () => onClickStop(stop),
                };
                const popUpElement = <MarkerDetailStopLineCard marker={formartedMarker} onClose={()=> onMarkerClose && onMarkerClose() /* setSelectedStop(null) */}/>;
                if (!markersStops.find((element: any) => element.id === stop.id)) {
                  markersStops.push({ ...formartedMarker, popUpElement });
                }
              }

              dispatch(updateStopsLine(markersStops));
              dispatch(updateMarkers(markersStops));
              dispatch(updateDrawMarker('startEndLine_' + line + '_' + paradasConLineas[0]?.id));
              // setStops(paradasConLineas);
            }
          })
          .finally(() => updateShowLoading(false));
      }
      const stopsInfo = paradasConLineas;
      return { stopsInfo };
    };

    const getStopsAndShape = async (line, direction, onClickStop, onMarkerClose) => {
      updateShowLoading(true);
      let paradasConLineas;
      if(line?.id && direction?.tripId) {
        await GetLineStopWithTrip({ id: line?.id, tripId: direction?.tripId })
          .then((response) => {
            if (response.status === 'rejected') {
              // setStops([]);
            } else {
              const paradasSinLineas = response.data;
              paradasConLineas = paradasSinLineas.map((stop) => {
                const lineasDeParada = stop.linesBoth;
                const paradaConLineaAux = {
                  ...stop,
                  lines: lineasDeParada
                    .filter((item) => item.routeId !== line.id)
                    .map((l) => selectorLines.find((item) => item.id === l.routeId))
                    .filter((item) => item !== undefined),
                };
                return paradaConLineaAux;
              });

              const markersStops: Array<any> = [];
              for (let i = 0; i < paradasConLineas.length; i++) {
                const stop = paradasConLineas[i];
                const index = i;

                let formartedMarker: any = {
                  id: stop.id,
                  position: { lat: stop.stopLat, lng: stop.stopLon },
                  data: {
                    name: stop.stopName,
                    stopCode:stop.stopCode,
                    routeColor: line.routeColor,
                    first: index === 0,
                    last:(paradasConLineas.length-1) === index,
                    onclickPasoPorParada: () => {
                      dispatch(updateMarkerSelected(stop.id));
                      dispatch(updateSelectedStop(stop));
                      dispatch(updateMarkerSelectedType(TYPES_MARKERS.STOP));
                      navigate(
                        generateUrl(RUTAS_GENERALES_MUL2.paradas, 'STOP', {
                          code: stop.stopCode,
                          name: stop.stopName,
                        }),
                      );
                    },
                  },
                  popUp: false,

                  type: 'CIRCLESTOP',
                  onClick: () => onClickStop(stop),
                };
                const popUpElement = <MarkerDetailStopLineCard marker={formartedMarker} onClose={()=> onMarkerClose && onMarkerClose() /* setSelectedStop(null) */}/>;
                if (!markersStops.find((element: any) => element.id === stop.id)) {
                  markersStops.push({ ...formartedMarker, popUpElement });
                }
              }

              dispatch(updateStopsLine(markersStops));
              dispatch(updateMarkers(markersStops));
              dispatch(updateDrawMarker('startEndLine_' + line + '_' + paradasConLineas[0]?.id));
              // setStops(paradasConLineas);
            }
          })
          .finally(() => updateShowLoading(false));
      };
      const directions = [...selectorDirections].sort((a, b) => {
        if (a.tripId === direction?.tripId) return -1;
        if (b.tripId === direction?.tripId) return 1;
        return 0;
      });

      // setRouteShapes([]);
      let shapes:any = [];

      for (let i = 0; i < directions.length; i++) {
        const dir:any = directions[i];
        try {
          let shapeData;

          if(line.id && dir.tripId) {
            const response = await GetLineShapeTrip({ id: line.id, tripId: dir.tripId });
            const coordinates = response.data?.map((s) => [s.latitude, s.longitude]) || [];
            shapeData = {
              id: response.data?.[0]?.id || null,
              positions: coordinates,
              color: dir.tripId === direction?.tripId ? `#${line.routeColor}` : '#718381',
              weight: 8,
              selected: dir.tripId === direction?.tripId,
            };
          }
          shapeData && shapes.push(shapeData);
        } catch (error) {
          console.error(`Error fetching shapes for tripId: ${dir.tripId}`, error);
        }
      }
      const stopsInfo = paradasConLineas;
      return { stopsInfo, shapes};
    };

    const getDirections = async (subLineId) => {
      let resDirections = [];
      if (subLineId) {
        await GetSubLineDirections(subLineId).then((result: any) => {
          if (result.data) {
            if (result.data.length) {
                resDirections = result.data.map(res => { return{...res, subLineId};});
              // dispatch(updateSelectedLineDirection(resDirections));
              // dispatch(updateDirections(result.data));
            } else {
              dispatch(
                updateContextualMessage({
                  message: t('lb_msj_error_generico'),
                  type: 'error',
                }),
              );
            }
          }
        });
      }
      return resDirections;
    };

    const getAllIntineraries = async () => {
      let shapes: any[] = [];

      if (subLinesSelector?.length) {
        const trips: any[] = [];
        const shapePromises = subLinesSelector.map((element: any) =>
          getDirections(element.subLineId)
            .then((res) => res) // Devuelve la respuesta
            .then(async (results: any) => {
              trips.push(...results.flat());
              const [from, to] = element.longName.split('-');

              // Genera las promesas para GetLineShapeTrip
              return Promise.all(
                trips.map((direction) =>
                  GetLineShapeTrip({ id: selectedLine?.id, tripId: direction?.tripId })
                    .then((response) => {
                      const coordinates = response.data?.map((s: any) => [s?.latitude, s?.longitude]);
                      const id = response.data?.length ? response.data[0]?.id : null;

                      return {
                        id,
                        positions: coordinates,
                        color:
                          selectedDirectionSelector?.tripId === direction?.tripId
                            ? `#${selectedLine?.routeColor}`
                            : '#718381',
                        weight: 8,
                        selected: selectedDirectionSelector?.tripId === direction?.tripId,
                        origin: from,
                        destination: to,
                      };
                    })
                )
              );
            })
            .catch((error) => {
              console.error('Error in processing trips or shapes:', error);
              return []; // Retorna un array vacío en caso de error para evitar problemas en `Promise.all`
            })
        );

        shapes = (await Promise.all(shapePromises)).flat(); // Espera la resolución de todas las promesas
      }

      return { shapes };
    };


    return { getLineInfo, setSmoothedPoints, getStops, getStopsAndShape, getAllIntineraries } as const;
}
